import React from 'react';
import PropTypes from 'prop-types';

const ActionCardComponent = ({ children }) => {
  const childArray = React.Children.toArray(children);

  const leftChildren = childArray.filter(child => child?.props?.['data-align'] === 'left');

  const rightChildren = childArray.filter(child => child?.props?.['data-align'] !== 'left');

  return (
    <div className="workspace-action-card flex flex-col items-center justify-between gap-4 rounded-t-md border p-4 md:flex-row">
      <div className="flex items-center gap-4">{leftChildren}</div>
      <div className="flex flex-wrap justify-end gap-4 ml-auto">{rightChildren}</div>
    </div>
  );
};

export default ActionCardComponent;

ActionCardComponent.propTypes = {
  children: PropTypes.node.isRequired
};
